import { colorPalette, colorTokens } from '../variables';

export const styles = {
  paper: {
    width: 400,
    display: 'flex',
    flexDirection: 'column',
    borderLeft: `3px solid ${colorPalette.neutralVariant90}`,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: '24px',
    py: '20px',
    flexShrink: 0,
    borderBottom: `1px solid ${colorPalette.neutralVariant90}`,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: colorPalette.navy20,
    lineHeight: 'normal',
  },
  closeButton: {
    color: colorPalette.neutralVariant60,
    p: 0,
    '&:hover': {
      bgcolor: 'transparent',
      color: colorPalette.navy20,
    },
  },
  sectionsContainer: {
    flex: 1,
    overflowY: 'auto',
  },
  sectionRow: {
    borderTop: `1px solid ${colorPalette.neutralVariant90}`,
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: '24px',
    py: '12px',
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      bgcolor: colorPalette.neutralVariant99,
    },
  },
  sectionHeaderDisabled: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: '24px',
    py: '12px',
    userSelect: 'none',
  },
  sectionHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  chevron: {
    fontSize: 16,
    color: colorPalette.navy20,
  },
  chevronDisabled: {
    fontSize: 16,
    color: colorPalette.neutralVariant60,
  },
  sectionLabel: {
    fontSize: 14,
    fontWeight: 500,
    color: colorPalette.navy20,
    letterSpacing: 'normal',
    lineHeight: 'normal',
  },
  sectionLabelDisabled: {
    fontSize: 14,
    fontWeight: 500,
    color: colorPalette.neutralVariant60,
    letterSpacing: 'normal',
    lineHeight: 'normal',
  },
  emptyMessage: {
    fontSize: 11,
    color: colorPalette.neutralVariant60,
    lineHeight: 'normal',
  },
  noResultsMessage: {
    fontSize: 13,
    color: colorPalette.neutralVariant60,
    lineHeight: 'normal',
    py: '4px',
  },
  badge: {
    bgcolor: colorPalette.orange73,
    color: colorPalette.neutral100,
    borderRadius: '9px',
    minWidth: 18,
    height: 18,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 10,
    fontWeight: 700,
    px: '4px',
  },
  searchContainer: {
    px: '12px',
    py: '8px',
    mx: '12px',
    my: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    bgcolor: colorPalette.neutral100,
    border: `1px solid ${colorPalette.neutralVariant90}`,
    borderRadius: '6px',
  },
  searchIcon: {
    fontSize: 16,
    color: colorPalette.neutralVariant60,
    flexShrink: 0,
  },
  searchInputBase: {
    fontSize: 13,
    color: colorTokens.text.dark,
    flex: 1,
    '& input::placeholder': {
      color: colorPalette.neutralVariant60,
      opacity: 1,
    },
  },
  showMoreButton: {
    font: 'inherit',
    border: 0,
    bgcolor: 'transparent',
    m: 0,
    textAlign: 'left',
    fontSize: 12,
    color: colorPalette.navy40,
    cursor: 'pointer',
    px: '38px',
    py: '4px',
    '&:hover': { textDecoration: 'underline' },
  },
  optionsList: {
    display: 'flex',
    flexDirection: 'column',
    pl: '38px',
    pr: '24px',
    pt: '4px',
    pb: '12px',
    gap: '8px',
  },
  checkboxFormControl: {
    mx: 0,
    gap: '6px',
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
      fontWeight: 400,
      color: colorTokens.text.dark,
      lineHeight: 'normal',
    },
  },
  checkbox: {
    p: '2px',
    color: colorPalette.neutralVariant90,
    '&.Mui-checked': {
      color: colorPalette.navy20,
    },
    '& .MuiSvgIcon-root': {
      fontSize: 18,
    },
  },
  footer: {
    flexShrink: 0,
    borderTop: `1px solid ${colorPalette.neutralVariant90}`,
  },
  footerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: '24px',
    py: '12px',
  },
};
